import { combineLatest } from 'rxjs/operator/combineLatest';

import {
  Injectable,
  ResolvedReflectiveProvider as RRP
} from '@angular/core';

import {
  Maybe,
  ContainerContent,
  Overlay,
  DialogRef,
  Modal as Modal_,
  CSSBackdrop,
  PromiseCompleter
} from 'angular2-modal';

import { BSModalContainer } from './modal-container.component';

import { OneButtonPresetBuilder } from './presets/one-button-preset';
import { TwoButtonPresetBuilder, PromptPresetBuilder } from './presets/two-button-preset';

// TODO: use DI factory for this.
// TODO: consolidate dup code
const /** @type {?} */ isDoc: boolean = !(typeof document === 'undefined' || !document);

let /** @type {?} */ animationClass: string = 'in';
/**
 * Execute this method to flag that you are working with Bootstrap version 4.
 * @return {?}
 */
export function bootstrap4Mode(): void {
  animationClass = 'show';
}
export class Modal extends Modal_ {
/**
 * @param {?} overlay
 */
constructor(overlay: Overlay) {
    super(overlay);
  }
/**
 * @return {?}
 */
alert(): OneButtonPresetBuilder {
    return new OneButtonPresetBuilder(this, /** @type {?} */(( <any>{isBlocking: false})));
  }
/**
 * @return {?}
 */
prompt(): PromptPresetBuilder {
    return new PromptPresetBuilder(this, /** @type {?} */(( <any>{isBlocking: true, keyboard: null})));
  }
/**
 * @return {?}
 */
confirm(): TwoButtonPresetBuilder {
    return new TwoButtonPresetBuilder(this, /** @type {?} */(( <any>{isBlocking: true, keyboard: null})));
  }
/**
 * @param {?} dialogRef
 * @param {?} content
 * @param {?=} bindings
 * @return {?}
 */
protected create(dialogRef: DialogRef<any>,
                   content: ContainerContent,
                   bindings?: RRP[]): Maybe<DialogRef<any>> {

    const /** @type {?} */ backdropRef = this.createBackdrop(dialogRef, CSSBackdrop);
    const /** @type {?} */ containerRef = this.createContainer(dialogRef, BSModalContainer, content, bindings);

    let /** @type {?} */ overlay = dialogRef.overlayRef.instance;
    let /** @type {?} */ backdrop = backdropRef.instance;
    let /** @type {?} */ container = containerRef.instance;

    dialogRef.inElement ? overlay.insideElement() : overlay.fullscreen();

    // add body class if this is the only dialog in the stack
    if (isDoc && !document.body.classList.contains('modal-open')) {
      document.body.classList.add('modal-open');
    }


    if (dialogRef.inElement) {
      backdrop.setStyle('position', 'absolute');
    }
    backdrop.addClass('modal-backdrop fade', true);

    backdrop.addClass(animationClass);
    container.addClass(animationClass);

    if (containerRef.location.nativeElement) {
      containerRef.location.nativeElement.focus();
    }

    overlay.beforeDestroy(() => {
      const /** @type {?} */ completer = new PromiseCompleter<void>();
      backdrop.removeClass(animationClass);
      container.removeClass(animationClass);

      combineLatest.call(backdrop.myAnimationEnd$(), container.myAnimationEnd$(), (s1, s2) => [s1,s2])
        .subscribe( sources => {
          isDoc && this.overlay.groupStackLength(dialogRef) === 1 && document.body.classList.remove('modal-open');
          completer.resolve();
        });

      return completer.promise;
    });

    return dialogRef;
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Overlay, },
];
}

function Modal_tsickle_Closure_declarations() {
/** @type {?} */
Modal.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Modal.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
